import React from "react";
import { useFeature } from "hooks/useFeature";

interface FeatureGateProps {
  feature: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const FeatureGate: React.FC<FeatureGateProps> = ({
  feature,
  children,
  fallback = null,
}) => {
  const { enabled } = useFeature(feature);

  if (!enabled) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default FeatureGate;
